<template>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6">
        <currencyinput
          name="issue_fee"
          label="Issue Fee"
          helper="Please enter the issue fee"
          v-model="form.issue_fee"
          :show-error="form.errors.has('issue_fee')"
          :error-message="form.errors.get('issue_fee')"
        ></currencyinput>

        <currencyinput
          name="counsel_fee"
          label="Counsel Fee"
          helper="Please enter the counsel fee"
          v-model="form.counsel_fee"
          :show-error="form.errors.has('counsel_fee')"
          :error-message="form.errors.get('counsel_fee')"
        ></currencyinput>

        <currencyinput
          name="dibs_total"
          label="Dibs Total"
          helper="Please enter the dibs total"
          v-model="form.dibs_total"
          :show-error="form.errors.has('dibs_total')"
          :error-message="form.errors.get('dibs_total')"
        ></currencyinput>
      </div>

      <div class="col-lg-6">
        <currencyinput
          name="hearing_fee"
          label="Hearing Fee"
          helper="Please enter the hearing fee"
          v-model="form.hearing_fee"
          :show-error="form.errors.has('hearing_fee')"
          :error-message="form.errors.get('hearing_fee')"
        ></currencyinput>

        <currencyinput
          name="other_fee"
          label="Other Fee"
          helper="Please enter other fees"
          v-model="form.other_fee"
          :show-error="form.errors.has('other_fee')"
          :error-message="form.errors.get('other_fee')"
        ></currencyinput>

        <currencyinput
          name="recovery_of_dibs_total"
          label="Recovery Of Dibs/Total"
          helper="Please enter the recovery of dibs/total"
          v-model="form.recovery_of_dibs_total"
          :show-error="form.errors.has('recovery_of_dibs_total')"
          :error-message="form.errors.get('recovery_of_dibs_total')"
        ></currencyinput>
      </div>
    </div>

    <div class="text-right mt-3">
      <form-button :indicator="processing" @clicked="submit">Save</form-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    section: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      processing: false,
      form: new window.Form({
        issue_fee: null,
        counsel_fee: null,
        dibs_total: null,
        hearing_fee: null,
        other_fee: null,
        recovery_of_dibs_total: null
      })
    };
  },

  watch: {
    section: {
      handler: 'hydrate',
      immediate: true
    }
  },

  methods: {
    hydrate(d) {
      if (!d) {
        return;
      }

      this.form.issue_fee = d.issue_fee;
      this.form.counsel_fee = d.counsel_fee;
      this.form.dibs_total = d.dibs_total;
      this.form.hearing_fee = d.hearing_fee;
      this.form.other_fee = d.other_fee;
      this.form.recovery_of_dibs_total = d.recovery_of_dibs_total;
    },

    submit() {
      this.processing = true;

      this.form
        .put(`/debt-recovery/${this.incident}/dibs-fees`)
        .then(data => {
          this.processing = false;
          this.form.errors.clear();
          this.$emit('saved', data);
          window.toastify.success(
            'Success!',
            'The dibs/fees were saved successfully!'
          );
        })
        .catch(() => {
          this.processing = false;
          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the dibs/fees'
          );
        });
    }
  }
};
</script>
